import React, { useEffect, useState } from 'react';
import axios from 'axios';

const API_BASE = 'https://besor3a.com/api';

export default function Wallet({ token }) {
  const [balance, setBalance] = useState(0);
  const [transactions, setTransactions] = useState([]);
  const [screen, setScreen] = useState('home');
  const [method, setMethod] = useState('');
  const [amount, setAmount] = useState('');
  const [receipt, setReceipt] = useState(null);
  const [msg, setMsg] = useState('');
  const [err, setErr] = useState('');
  const [loading, setLoading] = useState(false);

  const load = () => {
    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    axios.get(`${API_BASE}/wallet/balance`).then(r => setBalance(r.data.balance));
    axios.get(`${API_BASE}/wallet/transactions`).then(r => setTransactions(r.data.transactions));
  };

  useEffect(() => { load(); }, [token]);

  const handleMethodSelect = (m) => {
    setMethod(m); setErr(''); setMsg('');
    if (m === 'card') {
      setScreen('card');
    } else {
      setScreen('manual');
    }
  };

  const submitManual = async () => {
    if (!amount || parseFloat(amount) <= 0) return setErr('أدخل مبلغ صحيح');
    if (!receipt) return setErr('ارفع صورة الإيصال');
    setLoading(true); setErr('');
    try {
      const fd = new FormData();
      fd.append('receipt', receipt);
      const uploadRes = await axios.post(`${API_BASE}/uploads/receipt`, fd);
      const receiptUrl = uploadRes.data.url;
      await axios.post(`${API_BASE}/wallet/topup-request`, {
        amount: parseFloat(amount), method, reference: receiptUrl
      });
      setMsg('تم إرسال طلب الشحن، سيتم مراجعته من الإدارة وإضافة الرصيد خلال دقائق');
      setScreen('home'); setAmount(''); setReceipt(null);
      load();
    } catch(e) {
      setErr(e.response?.data?.error || 'حصل خطأ');
    }
    setLoading(false);
  };

  const TYPE_AR = { topup:'شحن ✅', topup_pending:'شحن (قيد المراجعة) ⏳', order_payment:'دفع رحلة 🛵', refund:'استرداد 💚' };

  if (screen === 'manual') return (
    <div style={S.page}>
      <div style={S.header}>
        <button onClick={()=>setScreen('home')} style={S.backBtn}>← رجوع</button>
        <h2 style={S.title}>{method === 'wallet' ? '📱 تحويل محفظة' : '📲 InstaPay'}</h2>
      </div>

      <div style={S.infoBox}>
        {method === 'wallet' ? (
          <>
            <p style={S.infoTitle}>📱 حول على رقم المحفظة</p>
            <p style={S.infoNum}>01066096604</p>
            <p style={S.infoSub}>يدعم: فودافون كاش، أورانج كاش، اتصالات كاش، WE</p>
            <p style={{margin:'12px 0 0',fontSize:'13px',color:'#f59e0b',fontWeight:'bold'}}>⏱️ سيتم إضافة الرصيد إلى محفظتك بعد دقائق من رفع الإيصال</p>
          </>
        ) : (
          <>
            <p style={S.infoTitle}>📲 حول عن طريق InstaPay</p>
            <p style={S.infoNum}>01277657727</p>
            <p style={S.infoSub}>من أي تطبيق بنكي يدعم InstaPay</p>
            <p style={{margin:'12px 0 0',fontSize:'13px',color:'#f59e0b',fontWeight:'bold'}}>⏱️ سيتم إضافة الرصيد إلى محفظتك بعد دقائق من رفع الإيصال</p>
          </>
        )}
      </div>

      <div style={S.form}>
        <label style={S.label}>المبلغ المحول (جنيه)</label>
        <input value={amount} onChange={e=>setAmount(e.target.value)} type="number" placeholder="مثال: 100" style={S.input}/>

        <label style={S.label}>صورة إيصال التحويل</label>
        <div style={S.uploadBox} onClick={()=>document.getElementById('receipt-input').click()}>
          {receipt ? (
            <div>
              <p style={{color:'#10b981', fontWeight:'bold'}}>✅ {receipt.name}</p>
              <p style={{color:'#888', fontSize:'12px'}}>اضغط لتغيير الصورة</p>
            </div>
          ) : (
            <div>
              <p style={{fontSize:'32px', margin:'0 0 8px'}}>📷</p>
              <p style={{color:'#666', margin:0}}>اضغط لرفع صورة الإيصال</p>
            </div>
          )}
        </div>
        <input id="receipt-input" type="file" accept="image/*" style={{display:'none'}} onChange={e=>setReceipt(e.target.files[0])}/>

        {err && <p style={S.err}>{err}</p>}

        <button onClick={submitManual} disabled={loading} style={S.submitBtn}>
          {loading ? '⏳ جاري الإرسال...' : '✅ إرسال طلب الشحن'}
        </button>
      </div>
    </div>
  );

  if (screen === 'card') return (
    <div style={S.page}>
      <div style={S.header}>
        <button onClick={()=>setScreen('home')} style={S.backBtn}>← رجوع</button>
        <h2 style={S.title}>💳 بطاقة بنكية</h2>
      </div>
      <div style={S.form}>
        <label style={S.label}>المبلغ (جنيه)</label>
        <input value={amount} onChange={e=>setAmount(e.target.value)} type="number" placeholder="أدخل المبلغ" style={S.input}/>
        {err && <p style={S.err}>{err}</p>}
        <button onClick={async () => {
          if (!amount || parseFloat(amount) <= 0) return setErr('أدخل مبلغ صحيح');
          try {
            const r = await axios.post(`${API_BASE}/wallet/kashier-topup`, { amount: parseFloat(amount) });
            window.location.href = r.data.paymentUrl;
          } catch(e) { setErr(e.response?.data?.error || 'حصل خطأ'); }
        }} style={S.submitBtn}>💳 الدفع الآن</button>
      </div>
    </div>
  );

  return (
    <div style={S.page}>
      <div style={{background:'linear-gradient(135deg,#10b981,#059669)', borderRadius:'20px', padding:'30px', textAlign:'center', marginBottom:'20px', color:'#fff'}}>
        <p style={{margin:'0 0 8px', fontSize:'14px', opacity:0.8}}>رصيد المحفظة</p>
        <h1 style={{margin:'0 0 4px', fontSize:'42px', fontWeight:'bold'}}>{balance.toFixed(2)}</h1>
        <p style={{margin:0, fontSize:'16px', opacity:0.8}}>جنيه مصري</p>
      </div>

      {msg && <div style={S.msgBox}>{msg}</div>}

      <h3 style={{margin:'0 0 12px', fontSize:'15px'}}>اختر طريقة الشحن</h3>
      <div style={{display:'grid', gridTemplateColumns:'1fr 1fr', gap:'12px', marginBottom:'24px'}}>
        {[
          ['wallet','📱','محفظة موبايل','فودافون/أورانج/اتصالات'],
          ['instapay','📲','InstaPay','من أي بنك'],
        ].map(([m,ic,title,sub])=>(
          <div key={m} onClick={()=>handleMethodSelect(m)} style={S.methodCard}>
            <span style={{fontSize:'28px'}}>{ic}</span>
            <p style={{margin:'8px 0 2px', fontWeight:'bold', fontSize:'14px'}}>{title}</p>
            <p style={{margin:0, fontSize:'12px', color:'#888'}}>{sub}</p>
          </div>
        ))}
      </div>

      <h3 style={{margin:'0 0 12px', fontSize:'15px', color:'#333'}}>سجل المعاملات</h3>
      {transactions.length === 0 ? (
        <div style={{textAlign:'center', padding:'30px', color:'#888'}}>
          <p style={{fontSize:'40px'}}>💳</p>
          <p>لا توجد معاملات بعد</p>
        </div>
      ) : transactions.map(t => (
        <div key={t.id} style={S.txCard}>
          <div>
            <p style={{margin:'0 0 4px', fontSize:'14px', fontWeight:'bold'}}>{TYPE_AR[t.type]||t.type}</p>
            <p style={{margin:'0 0 2px', fontSize:'12px', color:'#888'}}>{t.description}</p>
            <p style={{margin:0, fontSize:'11px', color:'#aaa'}}>{new Date(t.created_at).toLocaleString('ar-EG')}</p>
          </div>
          <div style={{textAlign:'left'}}>
            <p style={{margin:'0 0 4px', fontSize:'16px', fontWeight:'bold', color:t.type==='order_payment'?'#ef4444':'#10b981'}}>
              {t.type==='order_payment'?'-':'+'}{parseFloat(t.amount).toFixed(2)} ج
            </p>
            <p style={{margin:0, fontSize:'12px', color:'#888'}}>رصيد: {parseFloat(t.balance_after).toFixed(2)}</p>
          </div>
        </div>
      ))}
    </div>
  );
}

const S = {
  page: { direction:'rtl', padding:'20px', paddingBottom:'80px', background:'#f5f6fa', minHeight:'100vh' },
  header: { display:'flex', alignItems:'center', gap:'12px', marginBottom:'20px' },
  backBtn: { background:'none', border:'none', fontSize:'16px', cursor:'pointer', color:'#10b981' },
  title: { margin:0, fontSize:'18px', fontWeight:'bold' },
  infoBox: { background:'#fff', borderRadius:'16px', padding:'20px', textAlign:'center', marginBottom:'20px', boxShadow:'0 2px 10px rgba(0,0,0,0.08)' },
  infoTitle: { margin:'0 0 8px', fontSize:'14px', color:'#666' },
  infoNum: { margin:'0 0 8px', fontSize:'28px', fontWeight:'bold', color:'#10b981', letterSpacing:'2px' },
  infoSub: { margin:0, fontSize:'13px', color:'#888' },
  form: { background:'#fff', borderRadius:'16px', padding:'20px', boxShadow:'0 2px 10px rgba(0,0,0,0.08)' },
  label: { display:'block', fontSize:'13px', color:'#666', marginBottom:'6px', marginTop:'14px' },
  input: { width:'100%', padding:'12px', border:'1px solid #ddd', borderRadius:'10px', fontSize:'15px', boxSizing:'border-box', direction:'ltr' },
  uploadBox: { border:'2px dashed #ddd', borderRadius:'12px', padding:'24px', textAlign:'center', cursor:'pointer', marginTop:'4px' },
  submitBtn: { width:'100%', padding:'14px', background:'#10b981', color:'#fff', border:'none', borderRadius:'12px', fontSize:'15px', fontWeight:'bold', cursor:'pointer', marginTop:'20px' },
  err: { color:'#ef4444', fontSize:'13px', margin:'8px 0 0' },
  msgBox: { background:'#d1fae5', border:'1px solid #6ee7b7', borderRadius:'12px', padding:'14px', marginBottom:'16px', color:'#065f46', fontSize:'14px' },
  methodCard: { background:'#fff', borderRadius:'14px', padding:'16px', textAlign:'center', cursor:'pointer', boxShadow:'0 2px 8px rgba(0,0,0,0.06)', border:'2px solid transparent' },
  txCard: { background:'#fff', borderRadius:'12px', padding:'16px', marginBottom:'10px', display:'flex', justifyContent:'space-between', alignItems:'center', boxShadow:'0 1px 4px rgba(0,0,0,0.06)' },
};
